import { gql } from "@apollo/client";

import CreateConfigItemDialog from "./CreateConfigItemDialog";

const CREATE_ERRAND_TYPE = gql(`
  mutation CreateErrandType($name: String!)
  @permission(requires: manageOrgConfig)
  {
    createErrandType(name: $name) {
      id
      name
    }
  }
`);

type Props = {
  open: boolean;
  onClose: () => void;
};

const CreateErrandTypeDialog = ({ open, onClose }: Props) => (
  <CreateConfigItemDialog
    open={open}
    onClose={onClose}
    title="Create Errand"
    mutation={CREATE_ERRAND_TYPE}
    mutationName="createErrandType"
    redirectPath="/operate-config/errands"
  />
);

export default CreateErrandTypeDialog;
